module.exports = __webpack_public_path__ + "static/media/3_11.91dc14cb.png";